import { ConfigParser, ConfigParserError } from 'core/config/config-parser';
import { CharDimensions } from '../../text/text.model';

export class FontMetaDataConfigParser extends ConfigParser
{
  public constructor(genericConfigObject: any)
  {
    super(genericConfigObject);
    this.validateConfig();
  }

  /**
   * @throws ConfigParserError
   */
  private validateConfig(): void
  {
    if (this.genericConfigObject === undefined) {
      throw this.buildConfigParserError('font metadata are undefined');
    }

    if (this.genericConfigObject.unicode_ranges === undefined ||
        this.genericConfigObject.unicode_ranges.length === 0) {
      throw this.buildConfigParserError('unicode_ranges is undefined');
    }

    if (this.genericConfigObject.char_dimensions === undefined ||
        this.genericConfigObject.char_dimensions.length === 0) {
      throw this.buildConfigParserError('char_dimensions is undefined');
    }
  }

  /**
   * @throws ConfigParserError
   */
  public getUnicodeRanges(): Array<Array<number>>
  {
    const unicodeRanges = this.genericConfigObject.unicode_ranges;
    for (const unicodeRange of unicodeRanges) {
      if (unicodeRange.length < 1 || unicodeRange.length > 2) {
        throw this.buildConfigParserError('invalid format for unicode range');
      }
    }
    return unicodeRanges;
  }

  /**
   * @throws ConfigParserError
   */
  public getCharDimensions(): CharDimensions
  {
    let charDimensions: any = {};

    const json = this.genericConfigObject.char_dimensions;
    charDimensions.baseEM = json.base_em;
    charDimensions.widths = json.widths;
    charDimensions.maxBearing = json.max_bearing;
    charDimensions.minLeading = json.min_leading ? json.min_leading : 0;

    return charDimensions;
  }

  private buildConfigParserError(message: string): ConfigParserError
  {
    return new ConfigParserError(message,
        ['Font: ' + this.genericConfigObject.name]);
  }
}
